import React, { useEffect, useState } from "react";
import { ReactComponent as EditIcon } from '../assets/icons/edit.svg';
import AppInput from "./form/base/app-input";
import "./app-modal-edit-processor-transaction-id.scss";

interface AppModalEditProcessorTransactionIdProps {
  isVisible: boolean;
  transactionId: string;
  currentValue: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmAction: (transactionId: string, processorTransactionId: string) => Promise<void> | void;
  cancelAction: () => void;
}

const AppModalEditProcessorTransactionId: React.FC<AppModalEditProcessorTransactionIdProps> = ({
  isVisible,
  transactionId,
  currentValue,
  confirmLabel = "Save",
  cancelLabel = "Cancel",
  confirmAction,
  cancelAction,
}) => {
  const [value, setValue] = useState(currentValue ?? "");

  // Keep the input in sync when a different row is opened
  useEffect(() => {
    setValue(currentValue ?? "");
  }, [currentValue, transactionId]);

  if (!isVisible) return null;

  const trimmed = value.trim();
  const isDisabled = trimmed.length === 0 || trimmed === (currentValue ?? "").trim();

  return (
    <div className="app-modal-transaction-overlay">
      <div className="app-modal">
        <div className="modal-icon">
          <EditIcon />
        </div>
        <div className="modal-content">
          <p className="modal-text">Set Processor Transaction ID</p>
          <p className="modal-id">Transaction {transactionId}</p>
          <AppInput
            theme="filter"
            value={value}
            placeholder="Processor Transaction ID"
            onChange={(event) => setValue(event.target.value)}
          />
        </div>
        <div className="modal-actions">
          <button className="btn btn-cancel" onClick={cancelAction}>
            {cancelLabel}
          </button>
          <button
            className="btn btn-confirm"
            disabled={isDisabled}
            onClick={() => confirmAction(transactionId, trimmed)}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppModalEditProcessorTransactionId;
